
import { fr, enUS, es } from 'date-fns/locale';

/**
 * Gets the appropriate date-fns locale based on the current language
 */
export const getDateLocale = (language: string) => {
  switch (language) {
    case 'fr':
      return fr;
    case 'es':
      return es;
    default:
      return enUS;
  }
};
